import Quill from 'quill'

const Inline = Quill.import('blots/inline')

class PhotoArchiveFormat extends Inline {}

PhotoArchiveFormat.blotName = 'photo-archive'
PhotoArchiveFormat.tagName = 'span'
PhotoArchiveFormat.className = 'ql-photo-archive'

export default PhotoArchiveFormat
